export type User = {
    isAuth: boolean;
    login?: string;
    firstName?: string;
    lastName?: string;
    avatarSrc?: string;
    uid?: string;
    publicId?: string;
    isPublicProfile?: boolean;
};

export type UserContextValue = {
    user: User;
};

export type UserProviderProps = {
    children: React.ReactNode;
    initialUser?: User;
};

export enum AvatarSize {
    Small = 'small',
    Medium = 'medium',
    Big = 'big',
}
